import React,{ useState } from "react";

import { FiTrash, FiEdit } from "react-icons/all";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";

import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import {
  CreateNewMessages,
  UpdateMessages,
  deleteMessages,
  getMessages,
} from "../../Data/Messages";
import CreateMessage from "../../components/CreateMessage";

const MessagesListComponent = ({ messagesData }) => {
  const { data, id } = messagesData;
  const [openEdit, setEdit] = useState(false);

  return (
    <>
      <List key={id}>
        <ListItem>
          <ListItemText
            primary={`${data.title}`}
            secondary={`${data.duration}`}
          />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete">
              <DeleteIcon
                color="error"
                fontSize="large"
                onClick={async (_) => {
                  deleteMessages(id);
                  alert("Messages Deleted");
                }}
              />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => {
                setEdit(!openEdit);
              }}
            >
              <EditIcon color="primary" fontSize="large" />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        {openEdit && (
          <CreateMessage
            btnName="Edit"
            titleName="Edit Message"
            messagesData={messagesData}
            submitType="Edit"
          />
        )}
      </List>
      <Divider dark />
    </>
  );
};

export default MessagesListComponent;
